export default __webpack_public_path__ + "static/media/seeding-rate.64a5fc14.jpg";